
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Clock, HeartPulse, Users } from 'lucide-react';
import { AnimatedButton } from '@/components/AnimatedButton';

export const PremiumSection = () => {
  return (
    <section className="py-16 bg-[#1d2025] text-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <Badge className="mb-4 bg-amber-400 text-black hover:bg-amber-500">Premium</Badge>
          <h2 className="text-3xl font-bold mb-4">Premium Protection for Your Family</h2>
          <p className="text-lg text-white/80">Upgrade to premium for just $9.99/month after your first plan and get continuous support and protection.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-[#2a2e35] p-8 rounded-xl hover:bg-[#32363f] transition-colors">
            <Users size={30} className="text-amber-400 mb-4" />
            <h3 className="text-xl font-bold mb-3">Family Sharing</h3>
            <p className="text-white/70">Share your emergency plan with up to 5 family members so everyone stays informed and prepared.</p>
          </div>
          
          <div className="bg-[#2a2e35] p-8 rounded-xl hover:bg-[#32363f] transition-colors">
            <HeartPulse size={30} className="text-amber-400 mb-4" />
            <h3 className="text-xl font-bold mb-3">24/7 Virtual Assistant</h3>
            <p className="text-white/70">Chat with our virtual assistant anytime to get clarification or ask questions about your emergency plan.</p>
          </div>
          
          <div className="bg-[#2a2e35] p-8 rounded-xl hover:bg-[#32363f] transition-colors">
            <Clock size={30} className="text-amber-400 mb-4" />
            <h3 className="text-xl font-bold mb-3">Unlimited Plan Updates</h3>
            <p className="text-white/70">Update your emergency plan whenever your circumstances change, at no additional cost.</p>
          </div>
        </div>
        
        <div className="text-center max-w-2xl mx-auto mb-8">
          <p className="text-white/90 mb-6">
            Start with an individual plan for $29.99 and get a comprehensive emergency plan tailored to your needs. 
            Then upgrade to Premium for continuous protection and support.
          </p>
          <Link to="/pricing">
            <AnimatedButton className="font-medium bg-amber-400 hover:bg-amber-500 text-black px-8 py-6 text-lg">
              View Pricing Options
            </AnimatedButton>
          </Link>
        </div>
      </div>
    </section>
  );
};
